__turbopack_context__.v({
  "mainBadge": "VotableTag-module-scss-module__B7DhgW__mainBadge",
});
